import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import styled from 'styled-components'
import Form from '@rjsf/core'
import { FieldProps } from '@rjsf/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { externalTriggerClasses } from './utils/externalControl'
import { Title } from './Title'
import { CollapsibleFormContext } from './types'
import { FeedbotRjsfForm } from '../design-system/FeedbotRjsfForm'

interface State {
  expanded: boolean
}

export default class CollapsibleObject extends React.Component<FieldProps, State> {
  formComponentRef = React.createRef<Form<any>>()
  isFirstRenderCycle = true
  state = { expanded: false }

  componentDidMount() {
    this.isFirstRenderCycle = false
  }

  getCollapsibleGroup = (): string | undefined => this.props.uiSchema?.collapsibleGroup
  getFormContext = (): CollapsibleFormContext => this.props.formContext

  toggleCollapse = () => {
    const collapsibleGroup = this.getCollapsibleGroup()

    collapsibleGroup
      ? this.getFormContext()?.toggleFieldCollapse(collapsibleGroup, this.props.name)
      : this.setState(({ expanded }) => ({ expanded: !expanded }))
  }

  getIsExpanded = () => {
    const collapsibleGroup = this.getCollapsibleGroup()

    return collapsibleGroup
      ? this.getFormContext()?.collapsibleGroups[collapsibleGroup] === this.props.name
      : this.state.expanded
  }

  getSchema = () => {
    // CollapsibleObject subsection only receives a section of the original schema
    // We need to re-attach the definitions from the root schema
    const fullSchemaDefinitions = this.props.registry.rootSchema.definitions

    return {
      ...this.props.schema,
      definitions: _.merge({}, this.props.schema.definitions, fullSchemaDefinitions),
      title: undefined
    }
  }

  render() {
    const expanded = this.getIsExpanded()

    return (
      <Wrapper className={externalTriggerClasses.getWrapperClasslist(expanded)}>
        <TitleWrapper
          onClick={this.toggleCollapse}
          className={externalTriggerClasses.getTriggerClasslist()}
        >
          <IconWrapper>
            <FontAwesomeIcon icon={expanded ? 'chevron-up' : 'chevron-down'} />
          </IconWrapper>
          <Title title={this.props.schema.title} />
        </TitleWrapper>
        <FeedbotRjsfForm
          liveValidate={this.isFirstRenderCycle || expanded}
          tagName="div"
          schema={this.getSchema()}
          onChange={({ formData }) => this.props.onChange?.(formData)}
          uiSchema={this.props.uiSchema}
          formData={this.props.formData}
          className={classNames('form-collapsible', { 'form-collapsible-collapsed': !expanded })}
          formContext={this.props.formContext}
          ref={this.formComponentRef}
        >
          {/* We need to render something (anything goes) as children */}
          {/* otherwise RJSF renders a submit button  */}
          <div />
        </FeedbotRjsfForm>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  overflow: hidden;
`

const TitleWrapper = styled.div`
  display: flex;
  cursor: pointer;
`

const IconWrapper = styled.legend`
  padding: 0 5px;
  flex: 1;
`
